<template>
	<div >
	<div style="height: 100%;" :class="{ 'is-loading': init && loaded }">
		<div class="text-center v-center">
			<h1 class="text-loading">Carregando posts...</h1>
		</div>
	</div>
	<div class="am-blog" style="min-height: 99vh;"
		:class="{ 'is-idle': !init || !loaded }"
	>
		<div class="am-blog__background op-0" :data-src="background">
		</div>

		<div class="am-blog__container op-0">
			<div class="am-blog__wrapper">
				<header class="am-blog__header">
					<am-text class="am-blog__title am-blog__title--first" type="title">
						<span>
							{{ titles[0] }}
						</span>
					</am-text>
					<am-text class="am-blog__title am-blog__title--second" type="title">
						<span>
							{{ titles[1] }}
						</span>
					</am-text>
					<am-text class="am-blog__title am-blog__title--third" type="title">
						<span>
							{{ titles[2] }}
						</span>
					</am-text>
				</header>

				<am-text class="am-blog__text d-none d-md-block" type="body">
					{{ text }} 
				</am-text>
				<router-link class="open--modal text-white text-decoration-none" to="/blog">Saiba mais</router-link>

			</div>
			<div class="posts-holder">
				<router-link class="am-blog__img-btn" :to="{path: '/post/' + posts[0].slug}">
					<div class="am-blog__image post-height" :data-src="posts[0].img"> 
						<p class="am-blog__img-btn-text"><span class="text-uppercase">{{ posts[0].category.name }}</span><br> {{ posts[0].title }}</p> 
					</div>
				</router-link>
				<router-link class="am-blog__img-btn" :to="{path: '/post/' + posts[1].slug}">
					<div class="am-blog__image_bottom post-height" :data-src="posts[1].img"> 
						<p class="am-blog__img-btn-text"><span class="text-uppercase">{{ posts[1].category.name }}</span><br> {{ posts[1].title }}</p> 
					</div>
				</router-link>
			</div>

		</div>
	</div>
	</div>

</template>

<script>
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

import axios from 'axios';

export default {
	components: {
		'am-text': AMText,
	},

	props: {
		init: {
			type: Boolean,
			default: false
		},
		postsLoaded: {
			type: Boolean,
			default: false
		},
		API:{
			type: String,
			default: process.env.API

		},
		titles: {
			type: Array,
			default: () => ([
				'Lorem.',
				'Ipsum.',
				'Rules' 
			])
		},
		text: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		posts: {
			type: Array,
			default: [
				{
					id: 1, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				}
			]
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		/* image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		} */
	},
	
	data: () => ({
		loaded: false
	}),

	watch: {
		postsLoaded(value) {
			console.log("postsLoaded foi chamado  ***********")
			/* 
			console.log(value) */
			if (value && this.init)
				this.onLoad()
		},
		init(value) {
			console.log("init foi chamado ***********")
			/* console.log("init foi chamado com um valor ***********")
			console.log(value) */
			if (value && this.postsLoaded)
				this.onLoad()
		}
	},

	mounted() {
		/* console.log("init iniciado com o valor de  ***********")
		console.log(this.init) */
		/* axios
		.get(process.env.API + '/api/posts')
		.then(response => {
			this.posts = response.data.data;
			this.posts.forEach(p => {
				p.img = process.env.API + '/storage/posts/' + p.img;
			});
			this.postsLoaded = true;
			console.log("posts carregados internamente com sucesso"); 
			console.log(this.posts); 
		}) */

		/* if (this.init){
			console.log("on load chamado");
			this.onLoad();
			console.log(this.loaded);

		} */
	},

	methods: {
		start() {
			// Background
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog__image'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog__image_bottom'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			console.log("onload chamado");
			let images = this.$el.querySelectorAll('.am-blog__background')
			let imagesBlog = this.$el.querySelectorAll('.am-blog__image, .am-blog__image_bottom')
			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

				}
			})
			imagesBlog.forEach((image, index) => {
				
				let img = new Image()

				img.src = image.dataset.src
				console.log("data src setted")
				console.log(img.src)
				img.onload = () => {
					image.style.backgroundImage = `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #000000 100%), url(${this.posts[index].img})`
					console.log("on load inside 1")
					if (index + 1 == images.length) {
						console.log("this.loaded is being called *************");
						this.loaded = true
						this.start()
					}
				}
				/* this.loaded = true; */

			})
			/* console.log(this.loaded);
			console.log(this.init); */
			console.log(require('@/assets/images/hero/image.jpg'));
		}
	}
}
</script>

<style lang="scss">
.is-loading{
	display: none;
}

	@media only screen and (max-width: 990px) {
		.posts-holder{
			height: 50vh;

		}
		.post-height{
			height: 55% !important;
		}
	}

.text-loading{
	font-family: SanFrancisco;
	font-style: normal;
	font-weight: 100;
	font-size: 70px;
	line-height: 84px;
	letter-spacing: 0.01em;
	color: #99887F;
}
.v-center{
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.am-blog{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	
	&__img-btn-text{
		font-family: Khand;
		color: #fff;
		font-style: normal;
		font-weight: 300;
		font-size: 40px;
		line-height: 120%;
		letter-spacing: 0.01em;
		max-width: 573px;
		margin-left: 8%;
		bottom: 30px;
		position: absolute;
	}
	@include grid-media($smartphone-grid) {
		&__img-btn-text{
			font-size: 26px;
		}
	}

	&__img-btn-text span{
		font-family: Khand;
		color: #99887F;
		

		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 16px;

		background: #ffffff;
		border-radius: 100px;
		padding: 5px 25px;
	}

	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
	&__wrapper{
		flex: 1;
		@include grid-column(6);
	}
	&__background{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100px;
		opacity: 1;
		z-index: -1;
		background-size: cover;
		background-position: center;
	}
	&__header{
		margin-top: 54px;
		margin-bottom: 32px;
		padding-bottom: 24px;
		position: relative;
		&:after{
			content: "";
			position: absolute;
			width: 100%;
			height: 1px;
			bottom: -1px;
			background: rgba($c-gray, .6);
			transition: 1s $easeInOutQuad .75s;
		}
	}

	@include grid-media($smartphone-grid) {
		&__header{
			margin-bottom: 5px;
			padding-bottom: 5px;

		}
		&__header *{
			font-size: 40px;
			line-height: 45px;

		}
	}


	&__title{
		line-height: 56px;
		overflow: hidden;
		span{
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		flex: 1;
		background-size: cover;
		background-position: center;
	}
	&__image_bottom{
		flex: 1;
		background-size: cover;
		background-position: center;
	}

	&.is-idle{
			opacity: 0;
		.am-blog{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
		&.__loading{
			opacity: 1;
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
	}

	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 50%;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__image_bottom{
			position: absolute;
			top: 50%;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			height: 200px;
		}
		&__header{
			margin-top: 144px;
			&:after{
				width: 280px;
			}
		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
	}
}
</style>
